import React from "react";
import { Body } from "../assets/styles/styled-components/GlobalStyles";
import { useSelector } from "react-redux";
import { Grid } from "@mui/material";
import "../assets/styles/scss/Education.scss";
import image from "../assets/images/certificate.jpg";

export default function Education() {
  const collapsed = useSelector((state) => state.sidebar.isCollaped);
  return (
    <Body isCollapsed={collapsed}>
      <div className="content-body">
        <Grid
          container
          spacing={0}
          direction="row"
          alignItems="center"
          justifyContent="center"
          style={{ minHeight: "100vh" }}
        >
          <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
            <div>
              <img
                src={
                  "https://fph.tu.ac.th/uploads/fph/DownloadLogo/2018_Thammasat_main_logo%202561.png"
                }
                height={125}
                alt="Thammasat University Logo"
                id="thammasat-logo"
              />
              <h3>Thammsat University,</h3>
              <p style={{ paddingBottom: "20px" }}>
                Pathum Thani, Thailand
                <br />
                Bachelor of Engineering, Software Engineering
                <br />4<sup>th</sup> Year Student
                <br />
                GPA 3.53
              </p>
              <div className="certificate">
                <img
                  src={image}
                  width={300}
                  alt="Chanantaphon Chanuksri Profile"
                  id="certificate"
                />
                <p>"Top 5 highest average GPA"</p>
              </div>
            </div>
          </Grid>
          <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3870.137172055088!2d100.6038259506446!3d14.06907609360351!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x30e27fedd6032473%3A0x72e0d3cc7699cdac!2z4LiE4LiT4Liw4Lin4Li04Lio4Lin4LiB4Lij4Lij4Lih4Lio4Liy4Liq4LiV4Lij4LmMIFRhbWJvbiBLaGxvbmcgTnVuZywgQW1waG9lIEtobG9uZyBMdWFuZywgQ2hhbmcgV2F0IFBhdGh1bSBUaGFuaSAxMjEyMA!5e0!3m2!1sen!2sth!4v1663061112104!5m2!1sen!2sth"
                style={{ border: 0, alignSelf: "center" }}
                allowfullscreen=""
                loading="lazy"
                referrerpolicy="no-referrer-when-downgrade"
                title="Thammasat University"
              ></iframe>
            </div>
          </Grid>
        </Grid>
      </div>
    </Body>
  );
}
